import { render, staticRenderFns } from "./ServiceContractNotice.vue?vue&type=template&id=4a0dbba4&scoped=true&"
import script from "./ServiceContractNotice.vue?vue&type=script&lang=js&"
export * from "./ServiceContractNotice.vue?vue&type=script&lang=js&"
import style0 from "./ServiceContractNotice.vue?vue&type=style&index=0&id=4a0dbba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0dbba4",
  null
  
)

export default component.exports